import React, { useState, useRef } from "react";
import BillboardsMobileDropdown from './BillboardsMobileDropdown';
// Zustand
import { useStore } from "../../zustand";
// import { ReactComponent as Arrow } from "../../assets/icons/left_arrow.svg";
import BillboardTabs from '../BillboardUI/BillboardTabs';
// import ARLaunch from '../ButtonsUI/ARLaunch';
// import CartBtn from '../ButtonsUI/CartBtn';
// Styles
// import clsx from 'clsx';
import { makeStyles } from '@material-ui/core/styles';
import { billboardStyles } from "../../assets/jss/billboardStyles";
const useStyles = makeStyles(billboardStyles);

export default function BillboardFooter() {
    const [ready, setReady] = useState(false);
    const [state, setState] = useState({
        desktop_default: 127,
        mobile_default: 85.6,
        last_visible_index: 2,
        visible_thumbnails: [0,1,2]
    });
    const { vList } = useStore.getState().variants_payload;
    const variant_id = useStore.getState().variant_id;
    // const actions = useStore(state => state.actions);
    // const { intent } = useStore.getState().hrx;
    const { billboard_list } = vList[variant_id]
    const { dynamic_text_settings } = useStore.getState().store_settings;
    const reviews = useStore.getState().reviews;
    const video_desc = useStore.getState().video_desc;
    const spec_sheet = useStore.getState().spec_sheet;
    // const { addToCartBtn } = useStore.getState().settings;
    const { active_board, active_tab } = useStore(state => state.scene_controls);
    const { h1, p } = vList[variant_id].billboard_list[active_board].info;
    const classes = useStyles(dynamic_text_settings);
    // var sliderPause = false;

    const _handleTabSelect = (targetTab) => {
        //setState({ tab: targetTab }) // Update tab state
        useStore.setState(state => ({ 
            scene_controls: { 
                ...state.scene_controls,
                active_tab: targetTab
            }
        }));
        return false;
    }
    
    // const prev_arrow = useRef(null);
    // const next_arrow = useRef(null);
    const current_slider_margin_mobile = useRef(0)
    const current_slider_margin_desktop = useRef(0)
    const slider_track = useRef(null)

    // const slider_active = billboard_list.length > 3;
    
    // Initialize Slider
    React.useEffect(() => {
        if(billboard_list[active_board] && !ready) {
            setState(state => ({
                ...state,
            }));
            setReady(true);
        }
    }, [billboard_list, active_board, ready]);

    const _handleSliderMove = React.useCallback(() => {
        if (billboard_list.length < 3) return

        if(state.visible_thumbnails.includes(active_board)) return
        
        let direction =  state.last_visible_index < active_board ? 'next' : 'prev';

        let updated_visible_thumbnails = [...state.visible_thumbnails]
        let updated_last_visible;
        let margin_increment_desktop, margin_increment_mobile

        while(!updated_visible_thumbnails.includes(active_board)) {
            updated_last_visible = direction === 'next' ? state.last_visible_index += 1 : state.last_visible_index -= 1

            if(direction === 'next') {
                updated_visible_thumbnails.shift()
                updated_visible_thumbnails.push(updated_last_visible)
            } else {
                updated_visible_thumbnails.pop();
                updated_visible_thumbnails.unshift(updated_last_visible - 2);
            }

            let margin_number_mobile =  direction === 'next' ? -state.mobile_default : state.mobile_default;
            let margin_number_desktop =  direction === 'next' ? -state.desktop_default : state.desktop_default;

            margin_increment_mobile = current_slider_margin_mobile.current += margin_number_mobile;
            margin_increment_desktop = current_slider_margin_desktop.current += margin_number_desktop;
        }

        slider_track.current.style.marginLeft = margin_increment_mobile+'px';
        slider_track.current.style.marginTop = margin_increment_desktop+'px';

        _handleTabSelect(2)

        setState((state) => ({
            ...state,
            ...billboard_list[active_board].info,
            last_visible_index: updated_last_visible,
            visible_thumbnails: [...updated_visible_thumbnails]
        }))
        
    }, [active_board, state, billboard_list]);

    // Detect when to change slider position outside of click
    React.useEffect(() => {
        if(ready) _handleSliderMove();
    }, [ready, active_board, _handleSliderMove]);

    // Handle Only Arrow clicks for Carousel
    // const _handleArrowClick = (direction) => {
    //     let updated_last_visible = direction === 'next' ? state.last_visible_index += 1 : state.last_visible_index -= 1
        
    //     let updated_visible_thumbnails = [...state.visible_thumbnails]

    //     if(direction === 'next') {
    //         updated_visible_thumbnails.shift()
    //         updated_visible_thumbnails.push(updated_last_visible)
    //     } else {
    //         updated_visible_thumbnails.pop();
    //         updated_visible_thumbnails.unshift(updated_last_visible - 2);
    //     }

    //     let margin_number_mobile =  direction === 'next' ? -state.mobile_default : state.mobile_default;
    //     let margin_number_desktop =  direction === 'next' ? -state.desktop_default : state.desktop_default;

    //     let margin_increment_mobile = current_slider_margin_mobile.current += margin_number_mobile;
    //     let margin_increment_desktop = current_slider_margin_desktop.current += margin_number_desktop;

    //     slider_track.current.style.marginLeft = margin_increment_mobile+'px';
    //     slider_track.current.style.marginTop = margin_increment_desktop+'px';

    //     _handleTabSelect(2)

    //     setState((state) => ({
    //         ...state,
    //         last_visible_index: updated_last_visible,
    //         visible_thumbnails: [...updated_visible_thumbnails]
    //     }))

    //     // Arrow moves active board to + or - 1 position 
    //     let selected_poi_index = direction === 'next' ? active_board + 1 : active_board - 1

    //     actions.changePOI(selected_poi_index); // CHANGE POI
    // }

    // Handle direct click on Thumbnail for Active Board
    // const _handleSelectedPOI = (selected_poi_index) => {
    //     if(selected_poi_index === active_board) return false

    //     _handleTabSelect(2)

    //     actions.changePOI(selected_poi_index); // CHANGE POI
    // }

    if(!ready) return null
    
    return (
        <section className={classes.billboard_footer}>
            <div className={classes.billboard_icon}>
                <div className={classes.billboard_icon_content}>
                {/*<ARLaunch design="rotate_icon" />*/}
                {/* { ((intent === 'willQL') || (intent === 'canQL') || (intent === 'willSV') || (intent === 'canSV')) &&
                    <BtnLaunchAR button_type="rotate_icon" />
                }
                { ((intent === 'willDQL') || (intent === 'willDSV') || (intent === 'wontDQL') || (intent === "cant")) &&
                    <ViewSpaceBtn button_type="rotate_icon" /> 
                } */}
                </div>
            </div>
            {!reviews && 
                <BillboardsMobileDropdown />
            }
            {/*<div className={classes.billboard_pois}>
                <div className={classes.billboard_media}>
                    { slider_active &&
                        <button ref={prev_arrow}
                                className={clsx({
                                    [classes.arrow] : true,
                                    [classes.prev_arrow] : true,
                                    [classes.disabled_arrow] : state.last_visible_index < 3
                                })}
                                onClick={() => _handleArrowClick('prev')}>
                            <Arrow className={classes.arrow_style} />
                        </button>
                    }
                    <div className={`${classes.billboard_slider} ${vList[variant_id].options.length < 2 ? 'vertical_slider' : '' }`}>
                        <div ref={slider_track} className={classes.billboard_slider_track}>
                            { vList[variant_id].billboard_list.map((billboard, index) => {
                                return (
                                    <button className={clsx({
                                            [classes.image_container] : true,
                                            [classes.active_poi] : index === active_board
                                        })}
                                        key={index}
                                        data-index={index}
                                        onClick={() => _handleSelectedPOI(index)}
                                        style={{ backgroundImage: `url(${billboard.info.image_1.src})`}}
                                    />
                                )
                            })}
                        </div>
                    </div>
                    { slider_active &&
                        <button ref={next_arrow}
                                className={clsx({
                                    [classes.arrow] : true,
                                    [classes.next_arrow] : true,
                                    [classes.disabled_arrow] : state.last_visible_index === billboard_list.length - 1, // TODO: Update only blocking last one
                                })}
                                onClick={() => _handleArrowClick('next')}>
                            <Arrow className={classes.arrow_style} />
                        </button>
                    }
                </div>
            </div>*/}
            <BillboardTabs tab={active_tab} h1={h1.text} text={p.text} device="mobile" description={video_desc} spec={spec_sheet} />
            <div className={classes.billboard_footer_buttons}>
                {/*{ addToCartBtn && <CartBtn /> }*/}
                {/*<ARLaunch design="billboard" />*/}
            </div>
        </section>
    );
}


